var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "kt_brand",
      staticClass: "brand flex-column-auto",
      attrs: { id: "kt_brand" },
    },
    [
      _c(
        "div",
        { staticClass: "brand-logo" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", { attrs: { src: _vm.logoPath, alt: "Logo" } }),
          ]),
        ],
        1
      ),
      _vm.allowMinimize
        ? _c("div", { staticClass: "brand-tools" }, [
            _c(
              "button",
              {
                ref: "kt_aside_toggle",
                staticClass: "toggle-menu-btn",
                attrs: { id: "kt_aside_toggle" },
                on: {
                  click: function ($event) {
                    return _vm.onToggle()
                  },
                },
              },
              [_c("i", { class: _vm.toggleIconClass })]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }